'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentsApi = undefined;

var _maxSafeInteger = require('babel-runtime/core-js/number/max-safe-integer');

var _maxSafeInteger2 = _interopRequireDefault(_maxSafeInteger);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _DefaultStrategy = require('./pmtMethodsStrategies/DefaultStrategy');

var _DefaultStrategy2 = _interopRequireDefault(_DefaultStrategy);

var _utils = require('./utils');

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var instance = null;

/**
 * Encapsulate the interactions with the OpenBet payments api
 */
/*eslint complexity: ["error", 17]*/

var PaymentsApi = exports.PaymentsApi = function () {

  /**
   * PaymentsApi constructor ensure the PaymentsApi instance is a singleton.
   *
   * @param {object} config initial configuration
   *      overrideCache:bool - if true will override the existing cached instance, if any
   *      obURL:string - the OpenBet's PaymentsAPI endpoint
   *      filterPaymentMethodsStrategy - function to use to filter payment methods
   * @returns {PaymentsApi} a singleton PaymentsApi instance
   * @public
   */
  // default value
  function PaymentsApi() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, PaymentsApi);
    this.obUrl = '';
    this.obPmtApiInstance = null;
    this.pmtMethodsObj = null;
    this.filterPmt = new _DefaultStrategy2.default();
    this.customer = null;
    this.disableApplePay = false;

    this.handleComplete3DSPaymentResponse = function (amount, resolve, reject) {
      return function (err, data) {
        if (err) {
          return reject((0, _utils.uniformError)(err));
        }

        return resolve((0, _extends3.default)({
          amount: amount
        }, data));
      };
    };

    if (instance && !config.overrideCache) {
      return instance;
    }

    instance = null;

    if (!config.obURL) {
      throw new Error('OB endpoint URL must be provided to initialise the PaymentsAPI.');
    }
    this.obUrl = config.obURL;

    if (config.filterPaymentMethodsStrategy) {
      this.filterPmt = config.filterPaymentMethodsStrategy;
    }

    this.disableApplePay = config.disableApplePay;

    if (window.PaymentAPI && typeof window.PaymentAPI === 'function') {
      this.obPmtApiInstance = new window.PaymentAPI();
    } else {
      throw new Error('OB PMT API not found in global scope.');
    }

    instance = this;
    return instance;
  }

  /**
   * initializes the paymentsAPI
   * @return {Promise} a promise that resolves customer data
   */


  (0, _createClass3.default)(PaymentsApi, [{
    key: 'initPaymentsAPI',
    value: function initPaymentsAPI() {
      var _this = this;

      return new _promise2.default(function (resolve, reject) {
        if (_this.isObPmtApiInitialized()) {
          resolve(_this.obPmtApiInstance.customer);
        } else {
          _this.obPmtApiInstance.init(_this.obUrl, function (error) {
            if (error) {
              reject((0, _utils.uniformError)(error));
            }
            resolve(_this.obPmtApiInstance.customer);
          });
        }
      });
    }

    /**
     * Retrieve the list of payment methods available for a loggedin user
     *
     * @returns {Promise} return a promise containing payment methods data
     * @public
     */

  }, {
    key: 'getCustPaymentMethods',
    value: function getCustPaymentMethods() {
      var _this2 = this;

      return new _promise2.default(function (resolve, reject) {
        /**
         * Handles PMT api getCustPaymentMethods response
         *
         * @param {Object} error the error object
         * @param {Object} data the data object
         * @returns {void}
         */
        var handleResponse = function handleResponse(error, data) {
          if (error) {
            reject((0, _utils.uniformError)(error));
          }

          var paymentMethods = _this2.filterPmt.execute(data, _this2.disableApplePay);
          if (paymentMethods === null) {
            reject((0, _utils.uniformError)('APP_QD_ERR_NO_PMT_METHODS'));
          }

          _this2.pmtMethodsObj = data;
          resolve(paymentMethods);
        };

        if (!_this2.isObPmtApiInitialized) {
          reject('ObPmt not initialized');
        }

        _this2.obPmtApiInstance.getCustPaymentMethods(handleResponse);
      });
    }

    /**
     * Validated the deposit amount using OB api.
     *
     * @param {number} pmtMethodId  Payment method id
     * @param {string} amount the amount to validate
     * @returns {String} an error message if amount is invalid, null otherwise
     * @public
     */

  }, {
    key: 'syncSetDepositAmountIfValid',
    value: function syncSetDepositAmountIfValid(pmtMethodId, amount) {
      var triggerApplePay = this.pmtMethodsObj && this.pmtMethodsObj.lastActiveMethod === 'APAY' && !this.disableApplePay;
      var isCCAvailable = this.pmtMethodsObj && this.pmtMethodsObj.cardMethods[pmtMethodId];

      if (triggerApplePay || isCCAvailable) {
        var paymentMethod = triggerApplePay ? this.pmtMethodsObj.registeredMethods[0] : this.pmtMethodsObj.cardMethods[pmtMethodId];
        try {
          var pmtInfo = paymentMethod.info;
          var minDepAmt = pmtInfo.validation && pmtInfo.validation.minDepAmt;
          var maxDepAmt = pmtInfo.validation && pmtInfo.validation.maxDepAmt;
          var minAmtLimit = parseFloat(minDepAmt || pmtInfo.pmtMinAmt);
          var maxAmtLimit = parseFloat(maxDepAmt || pmtInfo.pmtMaxAmt);
          var nextDepAmt = parseFloat(pmtInfo.pmtNextDepAmt);
          var nextDepTime = pmtInfo.pmtNextDepTime;
          var nextDepDate = function nextDepDate() {
            var date = new Date(nextDepTime);
            return date.toLocaleDateString('en-GB', { timeZone: 'Europe/London' });
          };
          var nextDepHour = function nextDepHour() {
            return new Date(nextDepTime).toLocaleTimeString('en', {
              timeStyle: 'short',
              hour12: false,
              timeZone: 'Europe/London'
            });
          };
          // deposit limit reached
          if (minAmtLimit > maxAmtLimit || maxAmtLimit === 0) {
            if (nextDepAmt > 0 && nextDepTime) {
              return {
                code: 'PMT_VALIDATE_ERR_AMOUNT_NEXT_DEPOSIT_AMOUNT',
                message: 'quickdeposit:PMT_VALIDATE_ERR_AMOUNT_NEXT_DEPOSIT_AMOUNT',
                payload: {
                  pmtNextDepAmt: nextDepAmt.toFixed(2),
                  nextDepDate: nextDepDate(),
                  nextDepHour: nextDepHour()
                }
              };
            } else {
              return (0, _utils.uniformError)('PMT_VALIDATE_ERR_AMOUNT_LIMIT');
            }
          }
          paymentMethod.setField('amount', amount);
          return null;
        } catch (error) {
          return (0, _utils.uniformError)(error);
        }
      } else {
        return (0, _utils.uniformError)('APP_QD_ERR_NO_PMT_METHODS');
      }
    }

    /**
     * Validated the deposit amount using OB api.
     *
     * @param {number} pmtMethodId  Payment method id
     * @param {string} amount the amount to validate
     * @returns {Promise} a promise object
     * @public
     */

  }, {
    key: 'performDeposit',


    /**
     * Attempts to perform a deposit.
     *
     * @param {Object} paymentMethod creditCard or apple pay method
     * @param {string} pmtMethodId The id of the current selected payment method.
     * @param {string} amount The amount to deposit.
     * @param {string} cvv The cvv card code.
     * @param {string} expiryDate The card expiryDate.
     * @param {string} productSource The productSource of the deposit (e.g DQ).
     * @param {bool} needConsent The needConsent value (e.g true).
     * @returns {Promise} a promise object
     * @public
     */
    value: function performDeposit(paymentMethod, amount, cvv, expiryDate, productSource, needConsent) {
      var _this3 = this;

      return new _promise2.default(function (resolve, reject) {
        /**
         * Handles PMT api deposit response
         *
         * @param {Object} err the error object
         * @param {Object} data the data object
         * @returns {void}
         * @private
         */
        var handleResponse = function handleResponse(err, data) {
          if (err) {
            return reject((0, _utils.uniformError)(err));
          }
          return resolve((0, _extends3.default)({
            amount: amount
          }, data));
        };

        if (!_this3.isObPmtApiInitialized()) {
          return reject((0, _utils.uniformError)('APP_QD_ERR_PMT_API_NOT_INIT'));
        }

        if (!paymentMethod) {
          return reject((0, _utils.uniformError)('APP_QD_ERR_NO_PMT_METHODS'));
        }

        try {
          var doubleSubmitCode = (0, _utils.generateRandomString)(30);

          paymentMethod.setField('amount', amount);
          if (cvv) {
            paymentMethod.setField('cvv2', cvv);
          }
          if (expiryDate) {
            paymentMethod.setField('expiry_date', expiryDate);
          }
          paymentMethod.setField('product_source', productSource);
          if (needConsent) {
            paymentMethod.setField('update_cc_consent_given', needConsent);
          }
          paymentMethod.deposit(doubleSubmitCode, handleResponse);
          return null;
        } catch (error) {
          return reject((0, _utils.uniformError)(error));
        }
      });
    }
  }, {
    key: 'performCreditCardDeposit',
    value: function performCreditCardDeposit(pmtMethodId, amount, cvv, expiryDate, productSource, needConsent) {
      var cardMethod = null;
      if (this.pmtMethodsObj && this.pmtMethodsObj.cardMethods[pmtMethodId]) {
        cardMethod = this.pmtMethodsObj.cardMethods[pmtMethodId];
      }

      return this.performDeposit(cardMethod, amount, cvv, expiryDate, productSource, needConsent);
    }
  }, {
    key: 'performApayDeposit',
    value: function performApayDeposit(amount, productSource) {
      var apayMethod = null;
      if (this.pmtMethodsObj && this.pmtMethodsObj.registeredMethods && this.pmtMethodsObj.registeredMethods[0]) {
        apayMethod = this.pmtMethodsObj.registeredMethods[0];
      }

      return this.performDeposit(apayMethod, amount, null, null, productSource, null);
    }

    /**
     * Extract the 3D Secure parameters from the payment object
     *
     * @param {string} pmtMethodId The id of the current selected payment method.
     * @param {DepositResponseType} paymentDetails the details about the payment
     * @param {string} termUrl The 3ds termination url
     * @returns {Promise} a promise object
     * @public
     */

  }, {
    key: 'get3DSDetails',
    value: function get3DSDetails(pmtMethodId, paymentDetails, termUrl) {
      var _this4 = this;

      return new _promise2.default(function (resolve, reject) {
        if (!_this4.isObPmtApiInitialized()) {
          return reject((0, _utils.uniformError)('APP_QD_ERR_PMT_API_NOT_INIT'));
        }

        if (_this4.pmtMethodsObj && _this4.pmtMethodsObj.cardMethods[pmtMethodId]) {
          var tdsDetails = _this4.pmtMethodsObj.cardMethods[pmtMethodId].get3DSDetails(paymentDetails, termUrl);
          if (tdsDetails) {
            return resolve(tdsDetails);
          }
          return reject((0, _utils.uniformError)('APP_QD_ERR_FETCH_3DS'));
        }
        return reject((0, _utils.uniformError)('APP_ERR_NO_PMT_METHODS'));
      });
    }

    /**
     * Performs Frictionless Request
     *
     * @param {string} pmtMethodId The id of the current selected payment method.
     * @param {string} pmtId Openbet's Payment ID
     * @param {string} threeDSv2Token The threeDSv2Token value from the InitPaymentAuthResponse
     * @param {string} txnId EPG transaction id
     * @param {string} md Merchant details string from 3D Secure
     * @param {string} termUrl Return URL that EPG will use for redirecting back once the payment is completed
     * @param {BrowserData} gatheredBrowserData browser fingerprint gathered from 3DS helpers library
     * @returns {Promise} a promise object
     * @public
     */

  }, {
    key: 'threeDSv2FrictionlessRequest',
    value: function threeDSv2FrictionlessRequest(pmtMethodId, pmtId, threeDSv2Token, txnId, md, termUrl, gatheredBrowserData, threeDSVersion, methodCompletionInd) {
      var _this5 = this;

      return new _promise2.default(function (resolve, reject) {
        if (!_this5.isObPmtApiInitialized()) {
          return reject((0, _utils.uniformError)('APP_QD_ERR_PMT_API_NOT_INIT'));
        }

        /**
         * Handles Frictionless Response
         *
         * @param {Object} err the error object
         * @param {Object} data the data object
         * @returns {void}
         * @private
         */
        var handleResponse = function handleResponse(err, data) {
          if (err) {
            return reject((0, _utils.uniformError)(err));
          }

          return resolve((0, _extends3.default)({}, data));
        };

        if (_this5.pmtMethodsObj && _this5.pmtMethodsObj.cardMethods[pmtMethodId]) {
          _this5.pmtMethodsObj.cardMethods[pmtMethodId].process3DSv2Payment({
            // mandatory
            pmtId: pmtId,
            txnId: txnId,
            md: md,
            termUrl: termUrl,
            challengeWindowSize: gatheredBrowserData.challengeWindowSize,
            browserJavaScriptEnabled: gatheredBrowserData.browserJavaScriptEnabled,
            browserLanguage: gatheredBrowserData.browserLanguage,
            // optional
            threeDSv2Token: threeDSv2Token,
            methodCompletionInd: methodCompletionInd,
            threeDSVersion: threeDSVersion,
            // browser
            browserJavaEnabled: gatheredBrowserData.browserJavaEnabled,
            browserColorDepth: gatheredBrowserData.browserColorDepth,
            browserScreenHeight: gatheredBrowserData.browserScreenHeight,
            browserScreenWidth: gatheredBrowserData.browserScreenWidth,
            browserTimezone: gatheredBrowserData.browserTimezone
          }, handleResponse);

          return null;
        }
        return reject((0, _utils.uniformError)('APP_ERR_NO_PMT_METHODS'));
      });
    }

    /**
     * Completes a 3DS payment
     *
     * @param {string} pmtMethodId The id of the current selected payment method.
     * @param {string} amount the amount to deposit
     * @param {string} paRes Payer authentication response string from 3D Secure
     * @param {string} md Merchant details string from 3D Secure
     * @returns {Promise} a promise object
     * @public
     */

  }, {
    key: 'complete3DSPayment',
    value: function complete3DSPayment(pmtMethodId, amount, paRes, md) {
      var _this6 = this;

      return new _promise2.default(function (resolve, reject) {
        /**
         * Handles 3DS PMT api deposit response
         *
         * @param {Object} err the error object
         * @param {DepositResponseType} data the data object
         * @returns {void}
         * @private
         */
        var handleResponse = function handleResponse(err, data) {
          if (err) {
            return reject((0, _utils.uniformError)(err));
          }

          return resolve((0, _extends3.default)({
            amount: amount
          }, data));
        };

        if (!_this6.isObPmtApiInitialized()) {
          return reject((0, _utils.uniformError)('APP_QD_ERR_PMT_API_NOT_INIT'));
        }

        if (_this6.pmtMethodsObj && _this6.pmtMethodsObj.cardMethods[pmtMethodId]) {
          _this6.pmtMethodsObj.cardMethods[pmtMethodId].complete3DSPayment(paRes, md, handleResponse);
          return null;
        }
        return reject((0, _utils.uniformError)('APP_ERR_NO_PMT_METHODS'));
      });
    }

    /**
     * Completes a 3DS payment
     *
     * @param {string} pmtMethodId The id of the current selected payment method.
     * @param {string} amount the amount to deposit
     * @param {string} cRes Payer authentication response string from 3D Secure
     * @param {string} threeDSSessionData Merchant details string from 3D Secure
     * @returns {Promise} a promise object
     * @public
     */

  }, {
    key: 'complete3DSv2Payment',
    value: function complete3DSv2Payment(pmtMethodId, amount, cRes, threeDSSessionData) {
      var _this7 = this;

      return new _promise2.default(function (resolve, reject) {
        if (!_this7.isObPmtApiInitialized()) {
          return reject((0, _utils.uniformError)('APP_QD_ERR_PMT_API_NOT_INIT'));
        }

        if (_this7.pmtMethodsObj && _this7.pmtMethodsObj.cardMethods[pmtMethodId]) {
          _this7.pmtMethodsObj.cardMethods[pmtMethodId].complete3DSv2Payment(cRes, threeDSSessionData, _this7.handleComplete3DSPaymentResponse(amount, resolve, reject));
          return null;
        }
        return reject((0, _utils.uniformError)('APP_ERR_NO_PMT_METHODS'));
      });
    }

    /**
     * Returns function handling 3DS PMT api deposit response
     *
     * @param {string} amount the amount to deposit
     * @param {Function} resolve the promise resolve function
     * @param {Function} reject the promise reject function
     * @returns {Function} Function callback for complete payment
     * @private
     */

  }, {
    key: 'isObPmtApiInitialized',


    /**
     * Check if the OB PMT API is initialized already.
     *
     * @returns {boolean} false if not initialized, true otherwise
     * @private
     */
    value: function isObPmtApiInitialized() {
      return this.obPmtApiInstance && this.obPmtApiInstance.initialised;
    }

    /**
     * checks that the amount is between the allowed bondaries for the payment method
     * and returns:
     * - the minimum allowed amount if the default amount is below that value
     * - the maximum allowed amount if the default amount is above that value
     * - the default amount if the value is between allowed values
     * @param  {string} pmtMethodId the id of the payment method
     * @param  {number} defaultAmount the amount to be used as default
     * @return {number} the formatted allowed amount
     */

  }, {
    key: 'updateCustomerDetails',


    /**
     * Retrieve customer details
     *
     * Details will be stored in this.customer, with the following properties:
     *
     *  is_guest - boolean - Is the customer a guest (ie not logged in)?
     *  cust_id - string - Customer's ID in Openbet systems
     *  title - string - Customer address title
     *  first_name - string - Customer's first name
     *  last_name - string - Customer's last name
     *  lang - string - Language code
     *  acct_id - string - Customer's account number
     *  ccy_code - string - Customer's currency code
     *  pocf_pending - boolean - POCF customer status flag (If POCF is enabled)
     *
     * @returns {Promise} return a promise resolved to customer details
     * @public
     */
    value: function updateCustomerDetails() {
      var _this8 = this;

      return new _promise2.default(function (resolve, reject) {
        if (!_this8.isObPmtApiInitialized()) {
          return reject('ObPmt not initialized');
        }

        /**
         * Handles PMT api updateCustomerDetails response
         *
         * @param {Object} error            the error object
         * @param {Object} detailsData      the customer details data object
         * @returns {void}
         */
        var responseHandler = function responseHandler(error, detailsData) {
          if (error) {
            return reject((0, _utils.uniformError)(error));
          }

          if (typeof detailsData === 'undefined' || detailsData === null) {
            return reject(_constants.QDL_MISSING_CUSTOMER_DETAILS_MSG);
          }

          _this8.customer = detailsData;
          return resolve(detailsData);
        };

        return _this8.obPmtApiInstance.updateCustomerDetails(responseHandler);
      });
    }

    /**
     * Create a new payment method
     *
     * @param {Object} methodDetails  a method detail data, bin only required if type is card
     *
     * @returns {Promise} return a promise resolved to payment method builder
     * @public
     */

  }, {
    key: 'buildNewMethod',
    value: function buildNewMethod(methodDetails) {
      var _this9 = this;

      return new _promise2.default(function (resolve, reject) {
        if (!_this9.isObPmtApiInitialized()) {
          return reject('ObPmt not initialized');
        }

        if (typeof methodDetails === 'undefined' || methodDetails === null || !methodDetails.type || methodDetails.type === 'card' && !methodDetails.bin) {
          return reject(_constants.QDL_NO_METHOD_DETAILS_MSG);
        }

        /**
         * Handles PMT api buildNewMethod response
         *
         * @param   {Object}  error            the error object
         * @param   {Object}  paymentMethod    the payment method builder
         * @returns {void}
         */
        var responseHandler = function responseHandler(error, paymentMethod) {
          if (error) {
            return reject((0, _utils.uniformError)(error));
          }

          return resolve(paymentMethod);
        };

        return _this9.obPmtApiInstance.buildNewMethod(methodDetails, responseHandler);
      });
    }
  }], [{
    key: 'asyncSetDepositAmountIfValid',
    value: function asyncSetDepositAmountIfValid(pmtMethodId, amount) {
      return new _promise2.default(function (resolve, reject) {
        if (instance) {
          var isInvalid = instance.syncSetDepositAmountIfValid(pmtMethodId, amount);
          if (isInvalid) {
            return reject({ amount: isInvalid.message });
          }
        }
        return resolve(null);
      });
    }

    /**
     * helper method for validating a deposit amount from redux-form
     * @param  {string} amount the amount value to validate
     * @param  {Map} allValues all form values
     * @return {string} an error message if the amount is not valid, null otherwise
     */

  }, {
    key: 'setFormDepositAmountIfValid',
    value: function setFormDepositAmountIfValid(amount, allValues) {
      if (!instance) {
        return null;
      }
      var formattedAmount = (0, _utils.formatNumber)(amount, 2);
      var error = instance.syncSetDepositAmountIfValid(allValues.get(_constants.QD_RF_FIELD_CARDID), formattedAmount);
      return error || null;
    }
  }, {
    key: 'checkAmountBoundaries',
    value: function checkAmountBoundaries(pmtMethodId, defaultAmount) {
      var triggerApplePay = instance && instance.pmtMethodsObj && instance.pmtMethodsObj.lastActiveMethod === 'APAY' && !instance.disableApplePay;
      var isCCAvailable = instance && instance.pmtMethodsObj && instance.pmtMethodsObj.cardMethods[pmtMethodId];
      var amount = 0;
      if (triggerApplePay || isCCAvailable) {
        var paymentMethod = triggerApplePay ? instance.pmtMethodsObj.registeredMethods[0] : instance.pmtMethodsObj.cardMethods[pmtMethodId];
        var cardMethodInfo = (paymentMethod || {}).info;
        var initialAmount = (0, _utils.formatNumber)(String(defaultAmount), 2);
        var minDepAmt = cardMethodInfo.validation && cardMethodInfo.validation.minDepAmt;
        var maxDepAmt = cardMethodInfo.validation && cardMethodInfo.validation.maxDepAmt;
        var paymentMinAllowedAmount = (0, _utils.formatNumber)(String(minDepAmt || cardMethodInfo.pmtMinAmt || 0), 2);
        var paymentMaxAllowedAmount = (0, _utils.formatNumber)(String(maxDepAmt || cardMethodInfo.pmtMaxAmt || _maxSafeInteger2.default), 2);
        amount = Math.max(Number(initialAmount), Number(paymentMinAllowedAmount));
        if (paymentMaxAllowedAmount) {
          amount = Math.min(amount, Number(paymentMaxAllowedAmount));
        }
      }
      return (0, _utils.formatNumber)(String(amount), 2);
    }

    /**
     * Retrieves the formatted expiry date from the payment method
     * @param  {string} pmtMethodId the id of the payment method
     * @return {string} the formatted expiry date
     */

  }, {
    key: 'getExpiryDate',
    value: function getExpiryDate(pmtMethodId) {
      /**
       * left pads the value with zeros to guarantee its length is 2
       * @param  {string} value the value to be formatted
       * @return {string} the formatted value
       */
      var formatValue = function formatValue(value) {
        var formattedValue = String(value || '');
        while (formattedValue.length < 2) {
          formattedValue = '0' + formattedValue;
        }
        return formattedValue;
      };

      var expiryDate = '0000';
      if (instance && instance.pmtMethodsObj && instance.pmtMethodsObj.cardMethods[pmtMethodId]) {
        var cardMethodInfo = (instance.pmtMethodsObj.cardMethods[pmtMethodId] || {}).info;
        var expiryMonth = formatValue(cardMethodInfo.expiryMonth);
        var expiryYear = formatValue(cardMethodInfo.expiryYear);
        expiryDate = '' + expiryMonth + expiryYear;
      }
      return expiryDate;
    }
  }]);
  return PaymentsApi;
}();